export default "__VITE_ASSET__87d9c08b__"